import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.22,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
  exit: {
    opacity: 0,
    y: -6,
    transition: {
      duration: 0.16,
      ease: 'easeIn',
    },
  },
};

/**
 * Animated route / page transition wrapper leveraging framer-motion.
 * Provides subtle opacity and elevation entry on navigation changes.
 */
export default function PageTransition({ children, sx = {} }) {
  return (
    <Box
      component={motion.div}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      sx={{
        width: '100%',
        minHeight: '100%',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
